import i18n from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentVendorBranch } from '../../hooks/use-get-shipment-vendor-branch';

export const ShipmentVendorBranchSelect = ({
  placeholder = i18n.t('translation:default.fields.shipmentBranch.placeholder'),
  label = i18n.t('translation:default.fields.shipmentBranch.label'),
  rules = [],
  name,
  editMode,
  margin,
  id = '',
  customerId,
  tooltip = false,
  mode = '',
  showAll = false,
  disableValidation = false,
  onChange = () => {},
  labelWithValue = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetShipmentVendorBranch({ customerKey: customerId });

  return (
    <FormSelectBox
      loading={isLoading}
      options={showAll ? [{ label: t('translation:default.options.all'), value: '-1' }, ...options] : options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      id={id}
      tooltip={tooltip}
      mode={mode}
      disableValidation={disableValidation}
      onChange={onChange}
      labelWithValue={labelWithValue}
    />
  );
};
